import React from "react";
import { T } from "../../config/theme";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary caught:", error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      const accent = this.props.accent || "#8b5cf6";
      return (
        <div style={{ padding: "48px 24px", textAlign: "center" }}>
          <div style={{
            width: 56, height: 56, borderRadius: 16,
            background: "rgba(239,68,68,.08)", border: "1px solid rgba(239,68,68,.18)",
            display: "flex", alignItems: "center", justifyContent: "center",
            margin: "0 auto 16px", fontSize: 24,
          }}>!</div>
          <div style={{ fontSize: 16, fontWeight: 800, marginBottom: 6, color: T.text }}>Something went wrong</div>
          <div style={{ fontSize: 13, color: T.text3, marginBottom: 20, maxWidth: 360, margin: "0 auto 20px", lineHeight: 1.6 }}>
            This page encountered an error. Try refreshing or navigating to another page.
          </div>
          <button
            onClick={() => this.setState({ hasError: false, error: null })}
            style={{
              padding: "10px 24px", borderRadius: 10, border: "none",
              background: accent, color: "#fff", fontFamily: T.font,
              fontSize: 13, fontWeight: 700, cursor: "pointer",
            }}
          >Try Again</button>
        </div>
      );
    }
    return this.props.children;
  }
}
